export const PanoramaSizes = {
    SIZE_6144: '6144',
    SIZE_4096: '4096',
    SIZE_3072: '3072',
    SIZE_2048: '2048',
    SIZE_1024: '1024',
    SIZE_512: '512',
}

export const CursorState = {
    GRAB: 'grab',
    GRABBING: 'grabbing',
    POINTER: 'pointer',
}
